var _style, _polygon, _path, _polygon2, _polygon3, _path2, _circle, _path3, _g, _g2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.6 532.4",
    style: {
      enableBackground: "new 0 0 511.6 532.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2F2E41;}\n\t.st1{fill:#FFB6B6;}\n\t.st2{opacity:0.1;enable-background:new    ;}\n\t.st3{fill:#E6E6E6;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#3F3D56;}\n\t.st6{fill:#C0A964;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "454.5,405.2 454.5,405.4 466.5,532.4 378.9,532.4 367.5,454.4 362.5,530.4 272.5,529.4 282.1,429.7  290.2,383.4 290.2,383.4 291.4,376.4 452.1,376.4 452.3,379 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.9,478.8c9.3,1.7,19-8.8,21.6-23.3c1.2-6.4,0.8-12.5-0.8-17.5l1.4-8.4L269,316.5c0,0,44-88,44-103.2 c0-15.3-12.7-22.8-12.7-22.8l-17.2,0.2l-54,131.8l-9.7,97.4l-1.6,13.4c-3.2,4.1-5.7,9.7-6.9,16.1 C208.2,463.9,213.6,477.1,222.9,478.8L222.9,478.8z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "398,135.9 382,98.9 330,107.9 326.5,151.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "398,135.9 382,98.9 330,107.9 326.5,151.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511,212.9c0,0-37-69-44-76c-3.1-3.1-8-3.2-12.5-2.3L403,116.9l-17.5-9.8l-1.2,18.7l-57.3,10.3 c0.3-11.4,1.9-15.7,1.9-15.7l-21,24.6l-41,20l0,0.2c-3,1.1-5.9,2.8-8,5.8c-8,11-30,145-30,145l47,10l6.4-40.1l4.6,36.1l3.5,67.5 c0,0,64,55,95,35s69-19,69-19l0.9-31.3c0.7-1.1,1.1-1.7,1.1-1.7l-1-111v-29.5c7.6,10.6,16.8,19.7,27.5,24 C518,269.9,511,212.9,511,212.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 350.6,
    cy: 66.6,
    r: 47.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.9,80.1c0,0,4.2-14.6,13.5-13.5c9.4,1,11.4-7.3,9.4-11.4s-6.2-25-6.2-25s2.1-14.6-10.4-16.6 c-12.5-2.1-16.6-4.2-18.7-8.3c-2.1-4.2-33.3-8.3-43.7-2.1c-10.4,6.2-18.7,18.2-26,21.6c-7.3,3.4-13.5,9.6-9.4,20 c4.2,10.4,10.2,30.7,10.2,30.7s10.6-3.7,12.7,2.5s-6.2-2.1,4.2-18.7c10.4-16.6,10.4-33.3,27-27c16.6,6.2,35.4,4.2,33.3,16.6 C378.6,61.4,384.9,80.1,384.9,80.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M381.9,459.4H18.6C8.4,459.4,0,451,0,440.8v-193c0-10.3,8.4-18.6,18.6-18.6h363.3c10.3,0,18.6,8.4,18.6,18.6 v193C400.6,451,392.2,459.4,381.9,459.4L381.9,459.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.9,459.4H18.6C8.4,459.4,0,451,0,440.8v-193c0-10.3,8.4-18.6,18.6-18.6h363.3c10.3,0,18.6,8.4,18.6,18.6 v193C400.6,451,392.2,459.4,381.9,459.4L381.9,459.4z M18.6,232.2c-8.6,0-15.5,7-15.5,15.5v193c0,8.6,7,15.5,15.5,15.5h363.3 c8.6,0,15.5-7,15.5-15.5v-193c0-8.6-7-15.5-15.5-15.5H18.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 353.9,
    cy: 247.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 366.4,
    cy: 247.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 378.8,
    cy: 247.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,323.3c-1.3,0-2.3,1-2.3,2.3c0,0.6,0.2,1.2,0.7,1.6c0.4,0.5,1,0.7,1.7,0.7h349.2c1.3,0,2.3-1,2.3-2.3 c0-0.6-0.2-1.2-0.7-1.6c-0.4-0.5-1-0.7-1.7-0.7H26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.1,322.5v6.2H26.4c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-1.7,1.4-3.1,3.1-3.1H332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.8,310.8h-31.1c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2h31.1c3.4,0,6.2,2.8,6.2,6.2 S375.2,310.8,371.8,310.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168,278.1H28.8c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2H168c3.4,0,6.2,2.8,6.2,6.2S171.4,278.1,168,278.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.4,393.3c-1.3,0-2.3,1-2.3,2.3c0,0.6,0.2,1.2,0.7,1.6c0.4,0.5,1,0.7,1.7,0.7h349.2c1.3,0,2.3-1,2.3-2.3 c0-0.6-0.2-1.2-0.7-1.6c-0.4-0.5-1-0.7-1.7-0.7H26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,392.5v6.2H26.4c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-1.7,1.4-3.1,3.1-3.1H212.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.8,380.8h-31.1c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2h31.1c3.4,0,6.2,2.8,6.2,6.2 S375.2,380.8,371.8,380.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 426.3,
    cy: 70.4,
    rx: 48.7,
    ry: 47.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.8,46.4c-6.5,11.8-13,23.6-19.5,35.4c-4.1-7.3-8.2-14.6-12.4-21.9c-1.4-2.5-5.3-0.3-3.9,2.3 c4.8,8.5,9.6,17,14.4,25.4c0.8,1.4,3.1,1.5,3.9,0c7.1-13,14.3-26,21.4-38.9C448.1,46.1,444.2,43.8,442.8,46.4z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.5,196.2L445,172.9c0,0-1.9-15.5-11.1-21.1c-1.5-3.7-3.3-7.7-4.9-11c-4-7.9,2-22.9-3-22.9s-12.4,15.8-12,20 c0.3,3.2,3,8.9,3.5,13.9c-6.1,2.3-11,6.2-14.2,9.4c-2.8,2.7-3.8,6.8-2.7,10.5c3.2,10.8,11.1,33.2,22.5,33.2c15,0,19-3,19-3 s31,39,54,42S493.5,196.2,493.5,196.2L493.5,196.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6738f8ca92cfd8c5923a8327458dc946.svg";
export { ForwardRef as ReactComponent };